<div class="thumbnail-bar" #bar appClickOutside (onClickOutside)="onClose.emit()">
  <div class="thumbnail-bar-inner">
    @if (allowLoadingExtra()) {
      <div inViewNew rootMargin="0px 200px" (onInView)="loadMoreBefore.emit()"></div>
    }
    @for (asset of assets(); track asset.id) {
      <div
        #el
        class="thumbnail {{ asset.status }}"
        id="thumb-{{ asset.id }}"
        [class.selected]="selectedAssetId() === asset.id"
        (click)="onSwitchToAsset.emit(asset.id)"
      >
        <div class="asset-container" *inView="false">
          @if ((asset | canDisplayAsset) && asset.type !== 'audio') {
            <img
              [src]="
                asset.version_data
                  | assetVersionUrl
                    : asset
                    : asset.version_data.status
                    : el.clientWidth
                    : el.clientHeight
                    : !!gallery().watermark
              "
              loading="lazy"
              alt=""
            />
          } @else {
            <app-non-preview-file
              [asset]="asset"
              [gallery]="gallery()"
              [showFilename]="true"
              [darkBackground]="true"
              [showBorder]="true"
            ></app-non-preview-file>
          }
        </div>
        <div class="asset-name">
          @if (asset.status === 'approved') {
            <app-svg src="/assets/icons/flag-check.svg"></app-svg>
          } @else if (asset.status === 'rejected') {
            <app-svg src="/assets/icons/flag-cross.svg"></app-svg>
          }
          <span>{{ asset.name }}</span>
        </div>
      </div>
    }
    <div inViewNew rootMargin="0px 200px" (onInView)="loadMoreAfter.emit()"></div>
  </div>
</div>
